import { Avatar } from "../ui-bits";
import { formatDistanceToNow } from "date-fns";

export default function ActivitySection({ activities }) {
  return (
    <div className="space-y-2.5" data-testid="panel-activity">
      {activities.length === 0 && <p className="text-sm text-muted-foreground">No activity yet.</p>}
      {activities.map((a) => (
        <div key={a.id} data-testid={`activity-${a.id}`} className="flex gap-2.5 text-sm">
          <Avatar name={a.user_name || "?"} userId={a.user_id} size="sm" className="mt-0.5" />
          <div className="flex-1 min-w-0">
            <p><span className="font-semibold">{a.user_name}</span> <span className="text-muted-foreground">{a.detail}</span></p>
            <p className="text-[10px] text-muted-foreground">{formatDistanceToNow(new Date(a.created_at), { addSuffix: true })}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
